import React, { useEffect } from 'react'
import styled from 'styled-components'
import NextButton from 'features/createBp/components/atoms/NextButton'
import { getCart } from 'utils/localStorage'
import { useDispatch, useSelector } from 'react-redux'
import {
  getCheckoutSessionUrl,
  getPaymentProcessing
} from 'features/cart/ducks/selectors'
import { paymentInitRoutine } from 'features/cart/ducks/actions'

const PaymentButton = ({
  accepted,
  hasItems,
  hasAnnualSubscriptions,
  hasOneTimeItems
}) => {
  const dispatch = useDispatch()
  const checkoutSessionUrl = useSelector(getCheckoutSessionUrl)
  const paymentProcessing = useSelector(getPaymentProcessing)

  const handleClick = () => {
    if (paymentProcessing) {
      return
    }

    const cartItems = getCart()
    const payload = cartItems.map(item => ({ id: item }))

    dispatch(paymentInitRoutine({
      buildingPassportsList: payload
    }))
  }

  useEffect(() => {
    if (checkoutSessionUrl) {
      window.location.assign(checkoutSessionUrl)
    }
  }, [checkoutSessionUrl])

  const buttonLabel = hasAnnualSubscriptions
    ? hasOneTimeItems
      ? 'Continue to secure checkout'
      : 'Start annual subscription'
    : 'Pay once'

  return (
    <PayButton
      disabled={!accepted || !hasItems || paymentProcessing}
      onClick={handleClick}
    >
      {paymentProcessing ? 'Preparing secure checkout...' : buttonLabel}
    </PayButton>
  )
}

export default PaymentButton

const PayButton = styled(NextButton)`
  margin-top: 20px;
  font-weight: normal;
`
